import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import thunk from 'redux-thunk'
import {persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/es/stateReconciler/hardSet';
import persistedReducer from './rootReducer';
import crossBrowserListener from './crossBrowserListener';

const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function configureStore(history) {
  return createStore(
    persistedReducer(history),
    {},
    composeEnhancers(applyMiddleware(routerMiddleware(history), thunk))
  );
}

const history = createBrowserHistory();
const store = configureStore(history);
const persistor = persistStore(store);


window.addEventListener('storage', crossBrowserListener(store, {
  key: 'accuraiser-client-auth',
  storage,
  stateReconciler: hardSet
}));

window.store = store;

export {persistor, history, store}
